/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WMMobileTop_getLonewolfPersonalData$ref: FragmentReference;
declare export opaque type WMMobileTop_getLonewolfPersonalData$fragmentType: WMMobileTop_getLonewolfPersonalData$ref;
export type WMMobileTop_getLonewolfPersonalData = {|
  +getLonewolfPersonalData: ?{|
    +data: ?{|
      +user: ?{|
        +name: ?string,
        +points: ?number,
        +position: ?string,
      |},
      +current_group_number: ?number,
      +current_bid: ?number,
      +current_pool: ?number,
      +last_group: ?{|
        +group_number: ?number,
        +guests: ?$ReadOnlyArray<?string>,
        +winning_players: ?$ReadOnlyArray<?string>,
        +winning_money: ?number,
      |},
      +winnings_by_group: ?$ReadOnlyArray<?{|
        +group_number: ?number,
        +money: ?number,
        +user_won: ?boolean,
      |}>,
      +next_groups: ?$ReadOnlyArray<?{|
        +group_number: ?number,
        +players: ?$ReadOnlyArray<?{|
          +name: ?string,
          +percentage: ?number,
          +picked: ?boolean,
        |}>,
      |}>,
      +total_page: ?number,
      +cumulative_total_page: ?number,
    |}
  |},
  +$refType: WMMobileTop_getLonewolfPersonalData$ref,
|};
export type WMMobileTop_getLonewolfPersonalData$data = WMMobileTop_getLonewolfPersonalData;
export type WMMobileTop_getLonewolfPersonalData$key = {
  +$data?: WMMobileTop_getLonewolfPersonalData$data,
  +$fragmentRefs: WMMobileTop_getLonewolfPersonalData$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "group_number",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "WMMobileTop_getLonewolfPersonalData",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "event_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "guest_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "quarter_id",
      "type": "Int!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getLonewolfPersonalData",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "event_token",
          "variableName": "event_token"
        },
        {
          "kind": "Variable",
          "name": "guest_token",
          "variableName": "guest_token"
        },
        {
          "kind": "Variable",
          "name": "quarter_id",
          "variableName": "quarter_id"
        }
      ],
      "concreteType": "lonewolfPersonalLeaderboardType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "lonewolfPersonalDataType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "user",
              "storageKey": null,
              "args": null,
              "concreteType": "lonewolfPositionsType",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "points",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "current_group_number",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "current_bid",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "current_pool",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "last_group",
              "storageKey": null,
              "args": null,
              "concreteType": "lonewolfLastGroupType",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guests",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "winning_players",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "winning_money",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "winnings_by_group",
              "storageKey": null,
              "args": null,
              "concreteType": "lonewolfWinningsByGroupType",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "money",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "user_won",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "next_groups",
              "storageKey": null,
              "args": null,
              "concreteType": "lonewolfNextGroupType",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "players",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "lonewolfNextGroupPlayersType",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "percentage",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "picked",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "total_page",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cumulative_total_page",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '138ab6c465280e0cf23eba2cc125f04a';
module.exports = node;
